var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "1 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.95 5.2a5.369 5.369 0 0 0-6.938-.541 5.35 5.35 0 0 0-7.221.796 5.285 5.285 0 0 0 .284 7.221l5.28 5.26a2.37 2.37 0 0 0 3.315 0l5.28-5.26a5.3 5.3 0 0 0 1.55-3.738c0-1.4-.557-2.744-1.55-3.738m-1.199 6.309-5.28 5.252a.64.64 0 0 1-.707.14.6.6 0 0 1-.21-.14l-5.28-5.277a3.62 3.62 0 0 1 0-5.074 3.64 3.64 0 0 1 5.1 0 .85.85 0 0 0 1.208 0 3.64 3.64 0 0 1 5.101 0 3.617 3.617 0 0 1 .068 5.074z"
  })));
};
export default SvgHeart;